// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2zTC4","content":"styles_content__3oxUe","selectAll":"styles_selectAll__3HTq-"};